import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { ACCESSIBILITY_ROUTE, TERMS_OF_USE_ROUTE } from "@utils/Routes";
import i18n from "i18next";
import BasicDivider from "@components/divider/BasicDivider";

interface FooterProps {
  className?: string;
}

const Footer: FunctionComponent<FooterProps> = ({ className = "" }) => {
  return (
    <footer className={className}>
      <Link to={TERMS_OF_USE_ROUTE}>{i18n.t("footer.terms-of-use.link")}</Link>
      <BasicDivider variant="grey" className="footer-divider" />
      <Link to={ACCESSIBILITY_ROUTE}>
        {i18n.t("footer.accessibility.link")}
      </Link>
    </footer>
  );
};

export default Footer;
